import { colors } from '@src/components/ui/colors';
import { Theme } from './types';

export const baseTheme: Theme = {
    colors: {
        primary: {
            dark: {
                filled: colors['so-blue-0.8'],
                active: colors['so-blue-0.9'],
                hover: colors['so-blue-0.8'],
                text: colors.primaryWhite,
                border: colors['so-blue-0.8'],
                linearHover: colors['tr-black-0.08'],
                contentBg: colors.primaryWhite,
            },
            main: {
                filled: colors.primaryBlue,
                active: colors['so-blue-0.8'],
                hover: colors['so-blue-0.8'],
                text: colors.primaryWhite,
                border: colors.primaryBlue,
                linear: colors['so-black-0.48'],
                linearHover: colors['tr-blue-0.08'],
                lightFilled: colors.primaryWhite,
                divider: colors['so-black-0.08'],
            },
            light: {
                filled: colors['so-blue-0.08'],
                active: colors['so-blue-0.16'],
                hover: colors['so-blue-0.12'],
                text: colors.primaryBlue,
                border: colors['so-blue-0.08'],
                linearHover: colors['tr-blue-0.24'],
                contentBg: colors.primaryBlack,
            },
            linear: {
                filled: colors.primaryBlue,
                active: colors['so-blue-0.8'],
                hover: colors['so-blue-0.8'],
                text: colors.primaryWhite,
                border: colors['so-blue-0.8'],
                lightFilled: colors.primaryWhite,
                lightText: colors['so-black-0.48'],
                lightBorder: colors['so-blue-0.08'],
            },
        },
        secondary: {
            dark: {
                filled: colors['so-black-0.8'],
                active: colors['so-black-0.8'],
                hover: colors['so-black-0.8'],
                text: colors.primaryWhite,
                border: colors['so-black-0.8'],
                contentBg: colors['tr-black-0.04'],
            },
            main: {
                filled: colors.primaryBlack,
                active: colors['so-black-0.8'],
                hover: colors['so-black-0.8'],
                text: colors.primaryBlack,
                border: colors.primaryBlack,
                icon: colors.primaryBlack,
                surfaceBg: colors['so-black-0.08'],
                surfaceHover: colors['so-black-0.16'],
                contentBg: colors['so-black-0.04'],
                divider: colors['so-black-0.16'],
            },
            light: {
                filled: colors['so-black-0.08'],
                active: colors['so-black-0.16'],
                hover: colors['so-black-0.12'],
                text: colors['so-black-0.48'],
                border: colors['so-black-0.08'],
                surfaceBg: colors['so-black-0.04'],
                surfaceHover: colors['so-black-0.08'],
                contentBg: colors.primaryWhite,
                icon: colors.primaryBlack,
                divider: colors['so-black-0.16'],
            },
            linear: {
                filled: colors.primaryBlack,
                active: colors['so-black-0.8'],
                hover: colors['so-black-0.8'],
                text: colors.primaryWhite,
                border: colors['so-black-0.8'],
            },
        },
        success: {
            dark: {
                filled: colors['so-green-0.8'],
                active: colors['so-green-0.8'],
                hover: colors['so-green-0.8'],
                text: colors.primaryWhite,
                border: colors['so-green-0.8'],
            },
            main: {
                filled: colors.primaryGreen,
                active: colors['so-green-0.8'],
                hover: colors['so-green-0.8'],
                text: colors.primaryGreen,
                border: colors.primaryGreen,
                icon: colors.primaryGreen,
            },
            light: {
                filled: colors['tr-green-0.04'],
                active: colors['so-green-0.16'],
                hover: colors['so-green-0.12'],
                text: colors.primaryGreen,
                border: colors['so-green-0.12'],
                surfaceBg: colors['tr-green-0.04'],
                icon: colors.primaryGreen,
            },
            linear: {
                filled: colors.primaryGreen,
                active: colors['so-green-0.8'],
                hover: colors['so-green-0.8'],
                text: colors.primaryWhite,
                border: colors['so-green-0.8'],
            },
        },
        warning: {
            dark: {
                filled: colors['so-yellow-0.12'],
                active: colors['so-yellow-0.12'],
                hover: colors['so-yellow-0.12'],
                text: colors.primaryWhite,
                border: colors['so-yellow-0.12'],
            },
            main: {
                filled: colors.primaryYellow,
                active: colors['so-orange-0.8'],
                hover: colors['so-orange-0.8'],
                text: colors.primaryYellow,
                border: colors.primaryYellow,
                icon: colors.primaryYellow,
            },
            light: {
                filled: colors['tr-orange-0.04'],
                active: colors['so-orange-0.16'],
                hover: colors['so-orange-0.12'],
                text: colors.primaryYellow,
                border: colors['so-orange-0.12'],
                surfaceBg: colors['tr-orange-0.04'],
                icon: colors.primaryYellow,
            },
            linear: {
                filled: colors.primaryYellow,
                active: colors['so-orange-0.8'],
                hover: colors['so-orange-0.8'],
                text: colors.primaryWhite,
                border: colors['so-orange-0.8'],
            },
        },
        error: {
            dark: {
                filled: colors['red-0.8'],
                active: colors['red-0.8'],
                hover: colors['red-0.8'],
                text: colors.primaryWhite,
                border: colors['red-0.8'],
            },
            main: {
                filled: colors.primaryRed,
                active: colors['red-0.8'],
                hover: colors['red-0.8'],
                text: colors.primaryRed,
                border: colors.primaryRed,
                icon: colors.primaryRed,
            },
            light: {
                filled: colors['tr-red-0.04'],
                active: colors['red-0.16'],
                hover: colors['red-0.12'],
                text: colors.primaryRed,
                border: colors['red-0.12'],
                surfaceBg: colors['tr-red-0.04'],
                icon: colors.primaryRed,
            },
            linear: {
                filled: colors.primaryRed,
                active: colors['red-0.8'],
                hover: colors['red-0.8'],
                text: colors.primaryWhite,
                border: colors['red-0.8'],
            },
        },
        info: {
            dark: {
                filled: colors['so-blue-0.8'],
                active: colors['so-blue-0.9'],
                hover: colors['so-blue-0.8'],
                text: colors.primaryWhite,
                border: colors['so-blue-0.8'],
            },
            main: {
                filled: colors.primaryBlue,
                active: colors['so-blue-0.8'],
                hover: colors['so-blue-0.8'],
                text: colors.primaryBlue,
                border: colors.primaryBlue,
                icon: colors.primaryBlue,
            },
            light: {
                filled: colors['tr-blue-0.04'],
                active: colors['so-blue-0.16'],
                hover: colors['so-blue-0.12'],
                text: colors.primaryBlue,
                border: colors['so-blue-0.12'],
                surfaceBg: colors['tr-blue-0.04'],
                icon: colors.primaryBlue,
            },
            linear: {
                filled: colors.primaryBlue,
                linearHover: colors['tr-blue-0.08'],
                active: colors['so-blue-0.8'],
                hover: colors['so-blue-0.8'],
                text: colors.primaryWhite,
                border: colors['so-blue-0.8'],
            },
        },
        neutral: {
            dark: {
                filled: colors['so-black-0.8'],
                active: colors['so-black-0.8'],
                hover: colors['so-black-0.8'],
                text: colors.primaryWhite,
                border: colors['so-black-0.8'],
                surfaceBg: colors['so-black-0.16'],
                surfaceHover: colors['so-black-0.24'],
                contentBg: colors['so-black-0.08'],
                icon: colors.primaryWhite,
                divider: colors['so-black-0.32'],
            },
            main: {
                filled: colors['so-black-0.48'],
                active: colors['so-black-0.8'],
                hover: colors['so-black-0.8'],
                text: colors.primaryWhite,
                border: colors['so-black-0.48'],
                surfaceBg: colors['so-black-0.08'],
                surfaceHover: colors['so-black-0.16'],
                contentBg: colors['so-black-0.04'],
                icon: colors.primaryBlack,
                divider: colors['so-black-0.16'],
            },
            light: {
                filled: colors['so-black-0.08'],
                active: colors['so-black-0.16'],
                hover: colors['so-black-0.12'],
                text: colors['so-black-0.48'],
                border: colors['so-black-0.08'],
                surfaceBg: colors['so-black-0.04'],
                surfaceHover: colors['so-black-0.08'],
                contentBg: colors.primaryWhite,
                icon: colors.primaryBlack,
                divider: colors['so-black-0.16'],
            },
            linear: {
                filled: colors.primaryBlack,
                active: colors['so-black-0.8'],
                hover: colors['so-black-0.8'],
                text: colors.primaryWhite,
                border: colors['so-black-0.8'],
            },
        },
    },
};
